export default __webpack_public_path__ + "static/media/Sze_Resume.04e0b6eb.pdf";